import React from "react";
import {
  StatusTagContainer,
  StatusTagTypography,
} from "./StatusTag.styles";
import { VariantStyles, SizeStyles } from "./StatusTag.variants";
import { useTheme } from "@mui/material/styles";
import { Icon, IconName } from "../../icons";
import { ticketsStatusMessage } from "../../utils/constants";

export type StatusTagVariants =
  | "applicationPending"
  | "onStandByList"
  | "ticketOffer"
  | "ticketAccepted"
  | "pastShow"
  | "tickets"
  | "attended"
  | "noShow"
  | "declined"
  | "timedout"
  | "timedoutSms"
  | "awaitingResponse"
  | "offerExpired"
  | "turnedAway"
  | "checkInPending"
  | "checkedIn"
  | "checkInDeclined"
  | "ticketOrInterestRevoked";

export interface CustomStatusTagProps {
  variant: StatusTagVariants;
  size?: "sm" | "md" | "lg";
}

export const StatusTag = ({
  variant,
  size = "md",
  ...rest
}: CustomStatusTagProps) => {
  const theme = useTheme();

  const sizeStylesFn = SizeStyles(theme);
  const variantStylesFn = VariantStyles(theme);

  let icon: IconName;
  let statusMessage: string;
  let rotate = 0;
  switch (variant) {
    case "applicationPending":
      icon = "Clock";
      statusMessage = "Application Pending";
      break;
    case "onStandByList":
      icon = "ViewList";
      statusMessage = "On Standby List";
      break;
    case "ticketOffer":
      icon = "Sparkles";
      statusMessage = "Ticket Offer";
      break;
    case "offerExpired":
      icon = "Clock";
      statusMessage = "Ticket Offer Expired";
      break;
    case "turnedAway":
      icon = "Reply";
      statusMessage = "Ticket Turned Away";
      rotate = 90;
      break;
    case "pastShow":
      icon = "DesktopComputer";
      statusMessage = "Past Show";
      break;
    case "tickets":
      icon = "Ticket";
      statusMessage = ticketsStatusMessage;
      break;
    case "attended":
      icon = "Check";
      statusMessage = "Attended";
      break;
    case "ticketAccepted":
      icon = "Check";
      statusMessage = "Accepted";
      break;
    case "noShow":
      icon = "X";
      statusMessage = "No Show";
      break;
    case "declined":
      icon = "Hand";
      statusMessage = "Declined";
      break;
    case "timedout":
      icon = "Clock";
      statusMessage = "Ticket Offer Expired";
      break;
    case "timedoutSms":
      icon = "Clock";
      statusMessage = "SMS Expired";
      break;
    case "awaitingResponse":
      icon = "Clock";
      statusMessage = "Awaiting Response";
      break;
    case "checkInPending":
      icon = "Clock";
      statusMessage = "Check-in Pending";
      break;
    case "checkedIn":
      icon = "Check";
      statusMessage = "Checked-in";
      break;
    case "checkInDeclined":
      icon = "Hand";
      statusMessage = "Check-in Declined";
      break;
    case "ticketOrInterestRevoked":
      icon = "Hand";
      statusMessage = "Application Declined";
      break;
    default:
      icon = "Clock";
      statusMessage = "Application Pending";
      break;
  }

  return (
    <StatusTagContainer data-cy="status-tag">
      <StatusTagTypography sx={{...sizeStylesFn[size]}}>{statusMessage}</StatusTagTypography>
      <Icon icon={icon} size="sm" sx={{...variantStylesFn[variant]}} rotate={rotate} />
    </StatusTagContainer>
  );
};

export interface StatusTagProps
  extends React.ComponentProps<typeof StatusTag> {
  as?: React.ElementType;
}

StatusTag.displayName = "StatusTag";
